export default "__VITE_ASSET__BaZfi8lN__"